var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardReference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dashboard--reference_svg__clip0_61530_7354)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 15v1.5h3.44L1.5 21.44l1.06 1.06 4.94-4.94V21H9v-6H3zM19.5 15.75H18v3.75h1.5v-3.75zM16.5 12H15v7.5h1.5V12zM13.5 13.5H12v6h1.5v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 1.5H3A1.502 1.502 0 001.5 3v9H3V9.75h18L21.003 21H12v1.5h9a1.502 1.502 0 001.5-1.5V3A1.502 1.502 0 0021 1.5zM9 8.25H3V3h6v5.25zm1.5 0V3H21v5.25H10.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dashboard--reference_svg__clip0_61530_7354"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDashboardReference;